module.exports = __webpack_public_path__ + "img/bulma-dark.92c2bf96.png";